module.exports = __webpack_public_path__ + "static/media/eiffel_tower.42cdf7d6.svg";